import "@aws-amplify/ui-react/styles.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Authenticator,
  useTheme,
  Button,
  View,
  Card,
  Flex,
} from "@aws-amplify/ui-react";
import { Auth } from "aws-amplify";
import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import * as React from "react";
import { Card as BSCard } from 'react-bootstrap';
import GameCreate from './ui-components/GameCreate'
import FriendsCreate from './ui-components/FriendsCreate'
import GameSetup from "./ui-components/GameSetup";
import GamePlay from "./ui-components/GamePlay";
import GolfGame from './ui-components/GolfGame';
import GolfScorecard from './ui-components/GolfScorecard';
import GolfResults from './ui-components/GolfResults';

const components = {
  Header() {
    const { tokens } = useTheme();

    return (
      <View textAlign="center" padding={tokens.space.large}>
        <BSCard>
          <BSCard.Body>
            <BSCard.Title>Knights' Game Calculators</BSCard.Title>
            <BSCard.Text>
              Game Calculators available: <a href="https://en.wikipedia.org/wiki/Grass_(card_game)" target="_blank" rel="noreferrer">Grass</a> and <a href="https://en.wikipedia.org/wiki/Golf_(card_game)" target="_blank" rel="noreferrer">Golf</a>
            </BSCard.Text>
            <BSCard.Text>
              Use "Friends" to set up you & your friends names, then "Games" to get started!  
            </BSCard.Text>
          </BSCard.Body>
        </BSCard> 
      </View>
    );
  }
}

async function out() {
  const confirmed = window.confirm("Are you sure you want to sign out?");
  if (confirmed) {
    try {
        await Auth.signOut();
    } catch (error) {
        console.log('error signing out: ', error);
    }
  }
}

export default function App({ signOut }) {
  return (
    <Authenticator components={components}>
    <View className="App">
      <Card>
        <BrowserRouter>
          <Routes>
            <Route path="/player" element={<FriendsCreate />} />
            <Route path="/newgame" element={<GameCreate />} />
            <Route path="/golf" element={<GolfGame />} />
            <Route path="/golf-scorecard" element={<GolfScorecard />} />
            <Route path="/golf-results" element={<GolfResults />} />
            <Route path="/gamesetup" element={<GameSetup />} />
            <Route path="/gameplay" element={<GamePlay />} />
            <Route path="/" element={<GameCreate />} />
          </Routes>
          <AppFooter />
        </BrowserRouter>
      </Card>
    </View>
    </Authenticator>
  );
}

function AppFooter() {
  const location = useLocation();
  const navigate = useNavigate();
  const isMainMenu = location.pathname === "/" || location.pathname === "/newgame";

  return (
    <Flex justifyContent="center" gap="12px">
      {!isMainMenu && <Button onClick={() => navigate("/newgame")}>Main Menu</Button>}
      <Button onClick={out}>Sign Out</Button>
    </Flex>
  );
}

//export default withAuthenticator(App)

